import { HeroUIProvider } from '@heroui/react';
// import { I18nProvider } from '@react-aria/i18n';
import { ThemeProvider, type ThemeProviderProps } from 'next-themes';
import { Toaster } from 'react-hot-toast';
import { envVars, LOCALE } from '@/config';
import { Inspector } from '@/core/ui';
import { ApolloProvider, client } from '@/libs';

export function Providers({
  children,
  themeProps,
}: {
  children: React.ReactNode;
  themeProps?: Partial<ThemeProviderProps>;
}) {
  return (
    <ApolloProvider client={client}>
      <HeroUIProvider disableRipple locale={LOCALE} className='h-full text-foreground bg-background'>
        <ThemeProvider
          {...themeProps}
          attribute='class'
          storageKey='ques:theme'
          themes={['light', 'dark', 'modern', 'system']}
          enableSystem
          defaultTheme='system'
        >
          {/* <I18nProvider locale={LOCALE}> */}
          <Inspector enabled={envVars.screenDebug} />
          <Toaster position='top-right' />
          {children}
          {/* </I18nProvider> */}
        </ThemeProvider>
      </HeroUIProvider>
    </ApolloProvider>
  );
}
